import {
  Order,
  OrderCreationModel,
  QuotationResult,
  Shop,
  Card,
  Product,
} from '@core/hera-models';
import { Formula } from '@core/api/models';
import { OrderProduct } from '@views/meal/shared';

export interface OrderRequest {
  hasSessionId: boolean;
  order: OrderCreationModel;
  tableNumber: string;
}

export interface StorageOrder {
  orderId: string;
  quotation?: QuotationResult;
  tableNumber?: string | null;
  order?: Order;
}

export interface GroupedProducts {
  category: string;
  products: OrderProduct[];
  order: number;
}

export interface OrderToSendParams {
  sessionId?: string;
  products: OrderProduct[];
  guestEmail: string;
  tableNumber?: string;
  cardId: string;
}

export interface OrderToSend {
  order: OrderCreationModel;
  saveToState: StateOrder;
}

export interface StateOrder {
  session_id: string;
  guest_email: string;
  products: OrderProduct[];
  table_number: string | null | undefined;
}

export interface MealData {
  cardId: string;
  dateSelected: string;
  tableId: string;
  shopId: string;
  cards?: Card[];
  shop?: Shop;
  formulas?: Formula[];
  products?: Product[];
  isFormulaEdit?: boolean;
}

export enum PaymentStatus {
  TO_PAY = 'ToPay',
  PAID = 'Paid',
  REFUSED = 'Refused',
  DEFERRED_PAYMENT = 'DeferredPayment',
}

export enum CheckoutPaymentStatus {
  TO_SEND = 'ToSend',
  INTEGRATED = 'Integrated',
  FAILED = 'Failed',
}
